var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41148 5.86592C2.48088 5.09256 3.129 4.5 3.90547 4.5H12.0945C12.871 4.5 13.5191 5.09256 13.5885 5.86592L14.3065 13.8659C14.3853 14.7438 13.6938 15.5 12.8125 15.5H3.18753C2.30617 15.5 1.61475 14.7438 1.69353 13.8659L2.41148 5.86592Z",
    stroke: "#CECECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73244 5C9.90261 4.70583 10 4.36429 10 4C10 2.89543 9.10457 2 8 2C6.89543 2 6 2.89543 6 4C6 4.36429 6.09739 4.70583 6.26756 5H5.17071C5.06015 4.68722 5 4.35064 5 4C5 2.34315 6.34315 1 8 1C9.65685 1 11 2.34315 11 4C11 4.35064 10.9398 4.68722 10.8293 5H9.73244Z",
    fill: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaste);
export default __webpack_public_path__ + "static/media/taste.08f1f97b.svg";
export { ForwardRef as ReactComponent };